import UnrealizedPotential from './containers/UnrealizedPotentialContainer';

export default UnrealizedPotential;
